import { camelize } from '@src/packages/utils';

export const eventCounterNumberComponentTransformer = result => {
  const { data: agg } = camelize(result);
  if (!agg) {
    return {
      data: {
        total: 0,
      },
    };
  }

  const aggregations = agg?.aggregations;
  const value = aggregations?.componentsNested?.filterComponent?.total?.value || 0;

  return {
    value,
  };
};
